import React from 'react';
import { Box, Grid, Button, Container, Typography, TextField as MuiTextField, useTheme, useMediaQuery } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { MapComponent, ValidationSchema, ContactFormSubmission, ContactInfoSidebar } from '../components/Contact';

// Custom TextField to integrate MUI with Formik
const TextField = ({ ...props }) => (
  <Field {...props}>
    {({ field, form, meta }) => (
      <MuiTextField
        {...field}
        {...props}
        fullWidth
        variant="outlined"
        error={meta.touched && !!meta.error}
        helperText={meta.touched && meta.error}
      />
    )}
  </Field>
);

const ContactMain = () => {
  const sendEmail = ContactFormSubmission();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box>
      <Box
        sx={{
          mt: 6,
          backgroundImage: 'url("/assets/img/contact/contact-cover.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '100vh',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h1" component="h1"
          sx={{
            position: 'absolute',
            color: '#ffffff',
            textShadow: '2px 2px 8px #000000',
            fontWeight: 'bold',
            fontSize: { xs: '2rem', sm: '4rem', md: '6rem' }
          }}
        >
          Contact Us
        </Typography>
      </Box>

      <Grid container justifyContent="center" alignItems="flex-start" spacing={4} sx={{ mt: 8, px: 1 }}>
        <Grid item xs={12} md={8} lg={6.5}
          sx={{
            // maxWidth: '800px',
            mx: { xs: '1.5rem', sm: '2rem', md: '3rem', lg: '3rem' },
            p: { xs: 2, md: 4 },
            borderRadius: '2rem',
            background: '#f8f9fc',
            boxShadow: '3px 4px 8px rgba(0,0,0,0.1)',
            mb: 4,
          }}
        >

          {/* Contact Form Section, order adjusted for medium screens and up */}
          <Grid container spacing={2}>
            <Grid item xs={12} >
              <Typography variant="h4" component="h5" sx={{ fontWeight: 'bold', color: 'black', mb: 2, textAlign: 'center' }}>
                Direct contact us?
              </Typography>

              <Typography variant="body1" sx={{ mb: 2 }}>
                BEADS for Education is headquartered in Brookfield, CT, USA and operates programs exclusively in Kenya.
              </Typography>

              <Typography variant="body1" sx={{ mb: 4 }}>
                Any material generated outside Brookfield or the authorized programs in Kenya is not related to BEADS for Education, Inc.
              </Typography>

              <Formik
                initialValues={{
                  user_name: '',
                  user_email: '',
                  subject: '',
                  message: '',
                }}
                validationSchema={ValidationSchema}
                onSubmit={(values, { resetForm }) => sendEmail(values, resetForm)}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField label="Enter Your Name" name="user_name" required />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField label="Enter Your Email" name="user_email" required />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField label="Enter Your Subject" name="subject" required />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Enter Your Message"
                          name="message"
                          multiline
                          rows={4}
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button variant="contained" type="submit" disabled={isSubmitting}>
                          Send Message
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </Grid>

        {/* Sidebar Section with specific styling, positioned absolutely for md screens and up */}
        {isMdUp && (
          <Grid item md={8} lg={3} sx={{
            height: 'fit-content',
            my: 6,
            bgcolor: 'background.paper',
            borderRadius: '1rem',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            ml: { md: 1, lg: 2 },
            // mr: { md: 1, lg: 1 },
            width: { xs: '90%', md: '300px' },
            // border: '2px solid #cdcfd2',
          }}>
            <ContactInfoSidebar />
          </Grid>
        )}
      </Grid>

      {/* Render sidebar below for smaller screens */}
      {
        !isMdUp && (
          <Container sx={{
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            p: 2,
            mt: 2,
            mb: 4,
            width: 'auto',
            maxWidth: '800px',
            // mx: 'auto', 
          }}>
            <ContactInfoSidebar />
          </Container>
        )
      }

      <MapComponent />
    </Box >
  );
};

export default ContactMain;
